import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import ITreatmentCategory from '../../../app/_interfaces/ITreatmentCategory';

@Injectable({
  providedIn: 'root',
})
export class TreatmentsCategoriesService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<ITreatmentCategory[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/treatments-categories`,
      {}
    );
  }

  update(
    customers_id: number,
    treatments_categories_id: number,
    treatmentCategory: ITreatmentCategory
  ) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/treatments-categories/${treatments_categories_id}`,
      treatmentCategory
    );
  }

  create(customers_id: number, treatmentCategory: ITreatmentCategory) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/treatments-categories`,
      treatmentCategory
    );
  }

  delete(customers_id: number, treatments_categories_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/treatments-categories/${treatments_categories_id}`
    );
  }
}
